import { useState, useCallback } from "react";
import { useDebounce } from "./useDebounce";

export const useMapBbox = () => {
  const [bbox, setBbox] = useState(null);

  const debouncedBbox = useDebounce(bbox, 700);

  const updateBbox = useCallback((map) => {
    if (!map) return;

    const bounds = map.getBounds();

    setBbox({
      minLon: bounds.getWest(),
      minLat: bounds.getSouth(),
      maxLon: bounds.getEast(),
      maxLat: bounds.getNorth(),
    });
  }, []);

  return { debouncedBbox, updateBbox };
};